import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-codec",
  "use": "icon-codec-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-codec\"><path d=\"M378.1 140h130.5v798.3H378.1zM580.8 140h87v798.3h-87zM953.7 140h65.2v798.3h-65.2zM229.6 140h65.2v798.3h-65.2zM729.2 140h152.2v798.3H729.2zM5.1 140h152.2v798.3H5.1z\" p-id=\"1195\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol